import { AsyncPipe } from '@angular/common'
import { Component } from '@angular/core'
import { IonToast } from '@ionic/angular/standalone'

import { ToastService } from './toast.service'

@Component({
	selector: 'app-toast',
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss'],
	standalone: true,
	imports: [AsyncPipe, IonToast],
})
export class ToastComponent {
	constructor(public toastService: ToastService) {}

	// We'll add this to the dismiss button in the template
	dismiss(): void {
		this.toastService.dismissToast()
	}
}
